import React from "react";
import { useRouter } from "next/router";
import { Flex, Text, Button, Box } from "@chakra-ui/core";
import Image from "@pency/components/display/Image";
import Heading from "~/components/ui/Heading";
import { useTranslation } from "~/i18n/hooks";
import Head from "next/head";
import { i18n, Trans } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { getLocale } from "~/i18n/selectors";
import { traceI18nFiles } from "~/i18n/tracing";
import { useMediaQuery } from "~/utils/hooks/useMediaQuery";

const Tenant = () => {
  const router = useRouter();
  const locale = getLocale();
  const isMobile = useMediaQuery("(max-width:480px)");
  const t = useTranslation();

  const handleRedirect = () =>
    router.push(`${process.env.ADMIN_URL}/${router.query.tenant}`);

  return (
    <Box>
      <Head>
        <link href={`${process.env.URL}/${locale}`} rel="canonical" />
        <link href={process.env.URL} hrefLang="x-default" rel="alternate" />
        <link href={process.env.URL} hrefLang="es" rel="alternate" />
        <link href={`${process.env.URL}/pt`} hrefLang="pt" rel="alternate" />
        <link href={`${process.env.URL}/en`} hrefLang="en" rel="alternate" />
        <title>{t("meta.title")}</title>
        <meta content={t("meta.description")} name="description" />
        <meta content={t("meta.keywords")} name="keywords" />
        <meta content={t("meta.title")} name="twitter:title" />
        <meta content={t("meta.description")} name="twitter:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta content={`${process.env.URL}/${locale}`} property="og:url" />
        <meta content={t("meta.title")} property="og:title" />
        <meta content={t("meta.description")} property="og:description" />
        <meta content={t("meta.title")} property="og:image:alt" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image"
        />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta
          content="i3s5ctil62czt0b7w98rd307q8t940"
          name="facebook-domain-verification"
        />
      </Head>
      <Flex height="100vh" justifyContent="center" backgroundColor="#48BB78">
        <Flex
          alignItems="center"
          flexDirection="column"
          marginTop={{ base: "4rem", md: "2rem" }}
        >
          <Image
            src="/open.png"
            backgroundColor="#48BB78"
            width={{ base: "80%", md: "50%" }}
            height={{ base: "160px", md: "244px" }}
          />
          <Heading
            marginTop={{ base: "1.25rem", md: "1.25rem" }}
            fontWeight={700}
            fontSize={{ base: "2rem", md: "3.3rem" }}
            textAlign="center"
            color="#FFF"
          >
            {t("admin.titleOne")}
          </Heading>
          <Heading
            fontWeight={700}
            fontSize={{ base: "2rem", md: "3.3rem" }}
            textAlign={{ base: "center", md: "initial" }}
            color="#FFF"
          >
            {t("admin.titleTwo")}
          </Heading>
          <Text
            fontWeight={400}
            marginTop="1.5rem"
            textAlign="center"
            width={{ base: "90%", md: "45%" }}
            color="#162D27"
          >
            {t("admin.subtitle")}
          </Text>
          <Button
            width="60%"
            color="#22594B"
            marginTop="2rem"
            onClick={handleRedirect}
            fontSize={{base: "0.75rem", md: '1rem'}}
            paddingY={{base: '1.5rem'}}
          >
            {isMobile ? (
              <Trans i18nKey={t("admin.buttonMobile")} />
            ) : (
              t("admin.button")
            )}
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export const getServerSideProps = async ({ locale }) => {
  // Mantiene el config y los locales dentro del bundle de este lambda.
  traceI18nFiles();

  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default Tenant;
